const USP_POINTS = [
  { icon: "ri-home-4-line", text: "Own a Premium A-Frame Villa or Cottage" },
  { icon: "ri-line-chart-line", text: "Earn 26–40% Est. Annual Returns" },
  { icon: "ri-calendar-check-line", text: "Enjoy Personal Holiday Stays" },
  { icon: "ri-sun-line", text: "Year-Round Tourism, Events & Wedding Revenue" },
];

export default function UspCta() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20a%20row%20of%20luxury%20A-frame%20cabins%20nestled%20among%20lush%20green%20forest%20hills%20at%20golden%20sunrise%2C%20gentle%20morning%20mist%20over%20the%20valley%2C%20warm%20sunlight%20glow%2C%20serene%20and%20exclusive%2C%20warm%20green%20and%20golden%20tones%2C%20premium%20real%20estate%20aerial%20photography&width=1800&height=1100&seq=cta-nomad-1&orientation=landscape"
        alt="Aerial view of luxury A-frame cabins in a green forest valley"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-950/70 to-primary-950/85"></div>

      <div className="relative z-10 w-full px-4 md:px-8 max-w-4xl mx-auto text-center">
        <p className="font-heading text-accent-300 text-xl md:text-2xl italic">Build Wealth. Live Freely. Own Nature.</p>

        <h2 className="font-heading text-3xl md:text-5xl text-background-50 mt-4 leading-tight">
          Why This Opportunity Stands Out
        </h2>
        <p className="text-background-100/90 text-sm md:text-base mt-5 leading-relaxed max-w-2xl mx-auto">
          India&apos;s tourism, destination wedding and corporate retreat sectors are witnessing
          exceptional growth. Nomad Livings lets you own a premium lifestyle asset while earning
          recurring income from multiple professionally managed revenue streams.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mt-10 text-left">
          {USP_POINTS.map((point) => (
            <div
              key={point.text}
              className="flex items-start gap-3 rounded-2xl bg-background-50/10 backdrop-blur-sm border border-background-50/20 p-4"
            >
              <span className="flex items-center justify-center w-9 h-9 rounded-full bg-accent-500 text-background-50 shrink-0">
                <i className={`${point.icon} text-lg`}></i>
              </span>
              <span className="text-sm font-semibold text-background-50 leading-snug pt-1.5">
                {point.text}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <p className="font-heading text-background-50 text-2xl md:text-4xl leading-snug">
            Invest Today. Own a Luxury Villa.
            <span className="block italic text-accent-300">Earn Passive Income Tomorrow.</span>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto text-sm md:text-base font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-8 py-3.5 hover:bg-accent-600 transition-colors"
            >
              Schedule Your Site Visit
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://wa.me/918088330330"
              target="_blank"
              rel="nofollow noopener"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto text-sm md:text-base font-semibold whitespace-nowrap rounded-full bg-background-50 text-primary-800 px-8 py-3.5 hover:bg-background-100 transition-colors"
            >
              <i className="ri-whatsapp-line"></i> Chat on WhatsApp
            </a>
          </div>
          <p className="text-background-100/80 text-xs mt-6">
            📍 Limited inventory available — schedule your site visit today.
          </p>
        </div>
      </div>
    </section>
  );
}